// extracted by mini-css-extract-plugin
export default {"horizontal":"KpA7wg","large":"p1hQaI","vertical":"E9mXGi","bullet":"lCLxQg","a11y":"vKiyaE","a11Y":"vKiyaE"};